export const DASHBOARD = 'DASHBOARD';
export const Dashboard_LOGS = 'LOGS';

